<ion-header>
  <ion-toolbar>
    <ion-title>{{ texts.visa.titleSetVisa | translate }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid>
    <ion-row class="ion-padding">
      <ion-text>
        {{ texts.dayInfo.sureVisum | translate }}
      </ion-text>
    </ion-row>
    <ion-row class="ion-padding">
      <ion-col size="6" class="visum-grid-item">
        <mat-form-field appearance="outline">
          <mat-label>{{ texts.visa.lblVisaTo | translate }}</mat-label>
          <input matInput [matDatepicker]="picker" [formControl]="date" />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker">
          </mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </ion-col>
      <ion-col size="3" *ngIf="visumWithTime$ | async" class="visum-grid-item">
          <mat-form-field appearance="outline">
            <mat-label>{{ texts.visa.time | translate }}</mat-label>
            <input
              matInput
              [formControl]="time"
              type="time"
            />
          </mat-form-field>
          <ion-button (click)="updateAllComplete()">
            {{ texts.report.fullDay | translate }}
          </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-tab-button (click)="setVisum()">
      <ion-icon name="checkmark"></ion-icon>
      <ion-label>{{ texts.visa.btnSetVisa | translate }}</ion-label>
    </ion-tab-button>
    <ion-tab-button (click)="emitCancelEvent()" slot="end">
      <ion-icon name="arrow-back"></ion-icon>
      <ion-label>{{ texts.general.cancel | translate }}</ion-label>
    </ion-tab-button>
  </ion-toolbar>
</ion-footer>
